<template>
	<div v-if="showDelete" class="deleteBtnWrapper"
		 v-on:click.stop.prevent="deleteSlide()">
		<IconBase class="icon" iconName="Slide löschen" width="36" height="36" v-bind:interactive="false">
			<IconDelete/>
		</IconBase>
	</div>
</template>

<script>
	import Step from '@/services/Step';
	import IconBase from '@/components/icons/IconBase.vue';
	import IconDelete from '@/components/icons/IconDelete.vue';

	export default {
		name: "ShowEditDeleteSlide",
		components: {
			IconBase,
			IconDelete
		},
		props: [
			"deleteStep",
			"deleteType",
			"showDelete"
		],
		methods: {
			async deleteSlide() {
				console.log(this.deleteStep);
				if (this.deleteType === 'model') {
					this.deleteStep.model_slide = null;
				} else {
					this.deleteStep.wall_slide = null;
				}

				await Step.put(this.deleteStep);

				setTimeout(function () {
					this.$emit('reloadShow');
				}.bind(this), 200);
			}
		}
	}
</script>

<style scoped>
	.deleteBtnWrapper {
		position: absolute;
		bottom: 0;
		left: 0;
		right: 0;
		background: rgba(0, 0, 0, 0.5);
		overflow: hidden;
		width: 100%;
		height: 100%;
		opacity: 0;
		transition: visibility 0s, opacity 0.1s linear;
		display: flex;
		align-items: center;
		justify-content: center;
		cursor: pointer;
		z-index: 2;
	}

	.deleteBtnWrapper:hover {
		opacity: 1;
	}

	.deleteBtn {
		stroke: white;
		width: 60px;
		height: 60px;
	}

	.icon {
		stroke: white;
		fill: white;
	}

	.icon g {
		fill: white;
	}
</style>